module.exports = {
	Starling: require("./Starling").default,
	StatsDisplay: require("./StatsDisplay").default,
}